import React from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import twitter from "assets/img/icons/twitter.svg";
import facebook from "assets/img/icons/facebook.svg";
import instagram from "assets/img/icons/instagram.svg";
import youtube from "assets/img/icons/youtube.svg";
import tiktok from "assets/img/icons/tiktok.svg";
import logo from "assets/img/logo-genius-sports.svg";

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: ${({theme}) => theme.background.footer};
	color: ${({theme}) => theme.color.footer};
	text-align: center;
	padding: 33px 27px;

	@media (min-width: 769px) {
		text-align: left;
		flex-direction: row;
		justify-content: space-between;
		padding: 50px 100px;
	}
`;

const Info = styled.div`
	width: 100%;
	color: #848484;
	font-family: "Hind", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 26px;

	@media (min-width: 769px) {
		width: initial;
		font-size: 16px;
	}
`;

const SocialContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;

	@media (min-width: 769px) {
		gap: 32px;
		flex-direction: row;
		align-items: flex-end;
	}
`;

const Social = styled.div`
	width: 100%;

	@media (min-width: 769px) {
		width: initial;
		display: flex;
		flex-direction: column;
	}
`;

const Logo = styled.img`
	width: 91px;

	@media (min-width: 769px) {
		width: 103px;
	}
`;

const Link = styled.a``;

const Links = styled.div`
	margin: 5px 0 38px;
	display: flex;
	justify-content: space-around;
	color: #ffffff;

	@media (min-width: 769px) {
		margin: 14px 0 0;
		justify-content: flex-start;

		a {
			&:first-of-type {
				margin-right: 74px;
			}
		}
	}
`;

const ShareText = styled.div`
	font-weight: 700;
	font-size: 16px;
	line-height: 26px;
	margin-bottom: 14px;
`;

const ShareIcons = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	a {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		margin-right: 8px;

		img {
			width: 24px;
		}
	}
`;

export const Footer: React.FC = () => {
	const {t} = useTranslation();

	return (
		<Wrapper>
			<Info>
				<span>{t("footer.copyright")}</span>

				<Links>
					<Link href="https://www.cfl.ca/terms-of-use/">{t("footer.terms_of_use")}</Link>
					<Link
						target="_blank"
						rel="noopener noreferrer"
						href="https://www.cfl.ca/privacy-policy/">
						{t("footer.privacy_policy")}
					</Link>
				</Links>
			</Info>

			<SocialContainer>
				<Social>
					<ShareText>{t("footer.share")}</ShareText>

					<ShareIcons>
						<a href="https://twitter.com/CFL">
							<img src={twitter} alt="Twitter" />
						</a>
						<a href="https://www.facebook.com/CFL">
							<img src={facebook} alt="Facebook" />
						</a>
						<a href="https://instagram.com/cfl">
							<img src={instagram} alt="Instagram" />
						</a>
						<a href="https://www.youtube.com/CFL">
							<img src={youtube} alt="YouTube" />
						</a>
						<a href="https://www.tiktok.com/@cfl">
							<img src={tiktok} alt="Tiktok" />
						</a>
					</ShareIcons>
				</Social>

				<a href="https://geniussports.com/" target="_blank" rel="noopener noreferrer">
					<Logo src={logo} alt="Genius sports" />
				</a>
			</SocialContainer>
		</Wrapper>
	);
};
